import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";

interface GetQuestionnairesParams {
    count?: number;
    status?: "active" | "inactive" | "entered-in-error" | "draft";
    title?: string;
    publisher?: string;
    tag?: string;
    organization?: string;
}

export async function GetQuestionnaires({
    count = 100,
    status,
    title,
    publisher,
    tag,
    organization,
}: GetQuestionnairesParams) {
    let url = `${endpoints.ADMFHIR}/Questionnaire`;

    const queryParams: string[] = [];
    if (organization) queryParams.push(`organization=${encodeURIComponent(organization)}`);
    if (count) queryParams.push(`_count=${count}`);
    if (status) queryParams.push(`status=${status}`);
    if (title) queryParams.push(`title=${encodeURIComponent(title)}`);
    if (publisher) queryParams.push(`publisher=${encodeURIComponent(publisher)}`);
    if (tag) queryParams.push(`_tag=${encodeURIComponent(tag)}`);

    if (queryParams.length > 0) {
        url = `${url}?${queryParams.join("&")}`;
    }

    const bearerToken = await useAuth.getUserToken();
    const headers = {
        Accept: "*/*",
        Authorization: bearerToken,
        "Content-Type": "application/fhir+json",
    };

    const response = await useAxios
        .get(url, { headers, timeout: 20000 })
        .then((response) => {
            if (response.status !== HTTPResponseStatus.Success) {
                throw new Error(`GetQuestionnaires: ${response.status}`);
            }
            return response.data;
        })
        .catch((error) => {
            console.error("GetQuestionnaires ", error);
            // toast.error(`GetQuestionnaires Error: ${error?.response?.status}`);
            throw new Error();
        });

    if (response) return response;
}
